import type { PhotographerAvailability, Order, BookingConfirmation, LegalDocument, BookingCostItem, BookingNote, OrderCancellationLog, OrderRescheduleLog } from "../store/types";

// ─── Photographer Availability ────────────────────────────────────────────────

export const MOCK_PHOTOGRAPHER_AVAILABILITY: PhotographerAvailability[] = [
  {
    id: "avail-001",
    photographer_id: "ph-001",
    available_date: "2026-04-10",
    available_start_time: "09:00",
    available_end_time: "18:00",
    city: "Kyoto",
    status: "available",
    note: "Available for full-day shoot, Arashiyama preferred.",
    created_at: "2026-03-15T00:00:00Z",
    updated_at: "2026-03-15T00:00:00Z",
  },
  {
    id: "avail-002",
    photographer_id: "ph-001",
    available_date: "2026-04-12",
    available_start_time: "09:00",
    available_end_time: "18:00",
    city: "Kyoto",
    status: "booked",
    note: "Booked for ORD-001 (Wang Li-Hua)",
    created_at: "2026-03-15T00:00:00Z",
    updated_at: "2026-03-20T00:00:00Z",
  },
  {
    id: "avail-003",
    photographer_id: "ph-002",
    available_date: "2026-04-18",
    available_start_time: "10:00",
    available_end_time: "18:00",
    city: "Tokyo",
    status: "available",
    note: "",
    created_at: "2026-03-16T00:00:00Z",
    updated_at: "2026-03-16T00:00:00Z",
  },
  {
    id: "avail-004",
    photographer_id: "ph-003",
    available_date: "2026-04-20",
    available_start_time: "09:00",
    available_end_time: "17:00",
    city: "Osaka",
    status: "available",
    note: "Castle area preferred.",
    created_at: "2026-03-17T00:00:00Z",
    updated_at: "2026-03-17T00:00:00Z",
  },
  {
    id: "avail-005",
    photographer_id: "ph-004",
    available_date: "2026-04-22",
    available_start_time: "08:00",
    available_end_time: "17:00",
    city: "Kyoto",
    status: "booked",
    note: "Booked for ORD-003 (Lin Jing-Yi)",
    created_at: "2026-03-18T00:00:00Z",
    updated_at: "2026-03-21T00:00:00Z",
  },
  {
    id: "avail-006",
    photographer_id: "ph-001",
    available_date: "2026-04-15",
    available_start_time: "09:00",
    available_end_time: "12:00",
    city: "Kyoto",
    status: "blocked",
    note: "Personal commitment, unavailable.",
    created_at: "2026-03-10T00:00:00Z",
    updated_at: "2026-03-10T00:00:00Z",
  },
];

// ─── Orders ──────────────────────────────────────────────────────────────────

export const MOCK_ORDERS: Order[] = [
  {
    id: "ord-001",
    order_number: "ORD-2026-001",
    customer_name: "Wang Li-Hua",
    customer_email: "lihua.wang@gmail.com",
    customer_phone: "+886-912-345-678",
    service_id: "svc-kyoto-full",
    selected_city: "Kyoto",
    shoot_date: "2026-04-12",
    start_time: "09:00",
    end_time: "18:00",
    number_of_reels: 2,
    subtotal_twd: 32000,
    addons_total_twd: 3000,
    total_twd: 35000,
    currency: "TWD",
    order_status: "confirmed",
    payment_status: "paid",
    special_requests: "Please include Arashiyama bamboo grove and Gion.",
    internal_notes: "Confirmed photographer Kenji Yamamoto.",
    created_at: "2026-03-18T08:00:00Z",
    updated_at: "2026-03-20T10:00:00Z",
  },
  {
    id: "ord-002",
    order_number: "ORD-2026-002",
    customer_name: "Chen Mei-Ling",
    customer_email: "meiling.chen@mail.com",
    customer_phone: "+886-921-111-222",
    service_id: "svc-kyoto-video",
    selected_city: "Kyoto",
    shoot_date: "2026-04-18",
    start_time: "10:00",
    end_time: "18:00",
    number_of_reels: 3,
    subtotal_twd: 48000,
    addons_total_twd: 0,
    total_twd: 48000,
    currency: "TWD",
    order_status: "pending",
    payment_status: "unpaid",
    special_requests: "Short video for Instagram, vertical format.",
    internal_notes: "Awaiting photographer assignment.",
    created_at: "2026-03-19T14:00:00Z",
    updated_at: "2026-03-19T14:00:00Z",
  },
  {
    id: "ord-003",
    order_number: "ORD-2026-003",
    customer_name: "Lin Jing-Yi",
    customer_email: "jingyi.lin@example.com",
    customer_phone: "+886-933-222-333",
    service_id: "svc-kyoto-full",
    selected_city: "Kyoto",
    shoot_date: "2026-04-22",
    start_time: "08:00",
    end_time: "17:00",
    number_of_reels: 1,
    subtotal_twd: 32000,
    addons_total_twd: 5000,
    total_twd: 37000,
    currency: "TWD",
    order_status: "confirmed",
    payment_status: "partial",
    special_requests: "Customer brings own kimono. Shirakawa and Heian Shrine needed.",
    internal_notes: "Yuki Tanaka confirmed.",
    created_at: "2026-03-20T09:30:00Z",
    updated_at: "2026-03-21T11:00:00Z",
  },
  {
    id: "ord-004",
    order_number: "ORD-2026-004",
    customer_name: "Huang Xiao-Mei",
    customer_email: "xiaomei@example.com",
    customer_phone: "+886-905-444-555",
    service_id: "svc-tokyo-full",
    selected_city: "Tokyo",
    shoot_date: "2026-04-25",
    start_time: "10:00",
    end_time: "18:00",
    number_of_reels: 2,
    subtotal_twd: 35000,
    addons_total_twd: 0,
    total_twd: 35000,
    currency: "TWD",
    order_status: "completed",
    payment_status: "paid",
    special_requests: "",
    internal_notes: "Completed. 200 edited photos delivered.",
    created_at: "2026-03-10T11:00:00Z",
    updated_at: "2026-04-26T17:00:00Z",
  },
  {
    id: "ord-005",
    order_number: "ORD-2026-005",
    customer_name: "Zhang Wei",
    customer_email: "zhangwei@example.com",
    customer_phone: "+886-978-666-777",
    service_id: "svc-kyoto-video",
    selected_city: "Kyoto",
    shoot_date: "2026-05-01",
    start_time: "09:00",
    end_time: "18:00",
    number_of_reels: 4,
    subtotal_twd: 48000,
    addons_total_twd: 8000,
    total_twd: 56000,
    currency: "TWD",
    order_status: "confirmed",
    payment_status: "unpaid",
    special_requests: "Drone footage of Arashiyama. Please check permit.",
    internal_notes: "Drone flight permit for Arashiyama needs to be verified before confirmation.",
    created_at: "2026-03-22T09:00:00Z",
    updated_at: "2026-03-24T09:00:00Z",
  },
];

// ─── Booking Confirmations ────────────────────────────────────────────────────

export const MOCK_BOOKING_CONFIRMATIONS: BookingConfirmation[] = [
  {
    id: "bc-001",
    order_id: "ord-001",
    photographer_id: "ph-001",
    confirmation_status: "confirmed",
    confirmed_at: "2026-03-20T10:00:00Z",
    declined_at: null,
    replacement_required: false,
    note: "Confirmed. Will prepare Arashiyama + Gion route.",
    created_at: "2026-03-20T08:00:00Z",
    updated_at: "2026-03-20T10:00:00Z",
  },
  {
    id: "bc-002",
    order_id: "ord-002",
    photographer_id: "",
    confirmation_status: "pending",
    confirmed_at: null,
    declined_at: null,
    replacement_required: false,
    note: "Awaiting photographer assignment.",
    created_at: "2026-03-22T14:00:00Z",
    updated_at: "2026-03-22T14:00:00Z",
  },
  {
    id: "bc-003",
    order_id: "ord-003",
    photographer_id: "ph-004",
    confirmation_status: "confirmed",
    confirmed_at: "2026-03-21T11:00:00Z",
    declined_at: null,
    replacement_required: false,
    note: "Yuki confirmed Shirakawa and Heian Shrine route.",
    created_at: "2026-03-21T10:00:00Z",
    updated_at: "2026-03-21T11:00:00Z",
  },
  {
    id: "bc-004",
    order_id: "ord-005",
    photographer_id: "ph-001",
    confirmation_status: "pending",
    confirmed_at: null,
    declined_at: null,
    replacement_required: false,
    note: "Pending drone permit verification for Arashiyama.",
    created_at: "2026-03-24T09:00:00Z",
    updated_at: "2026-03-24T09:00:00Z",
  },
  {
    id: "bc-005",
    order_id: "ord-004",
    photographer_id: "ph-002",
    confirmation_status: "confirmed",
    confirmed_at: "2026-04-10T11:00:00Z",
    declined_at: null,
    replacement_required: false,
    note: "Completed. Saki delivered 200 photos.",
    created_at: "2026-04-08T09:00:00Z",
    updated_at: "2026-04-26T17:00:00Z",
  },
];

// ─── Legal Documents ──────────────────────────────────────────────────────────

export const MOCK_LEGAL_DOCUMENTS: LegalDocument[] = [
  {
    id: "legal-001",
    doc_type: "terms",
    doc_key: "terms_v2",
    title_i18n: {
      "zh-TW": "服務條款",
      "en-US": "Terms of Service",
      "ja-JP": "利用規約",
    },
    content_i18n: {
      "zh-TW": "本服務條款規範您使用 TaBiFoTo 旅拍攝影服務的相關事項。使用本服務即表示您同意受本條款約束。\n\n1. 服務範圍：TaBiFoTo 提供在日本指定城市的專業旅遊攝影服務。\n2. 預訂確認：訂單確認後 72 小時內完成支付方視為有效預訂。\n3. 取消政策：拍攝日前 14 天以上取消退還 80% 費用；7 天以上退還 50%；7 天內不退款。",
      "en-US": "These Terms of Service govern your use of TaBiFoTo travel photography services. By using our services, you agree to be bound by these Terms.\n\n1. Service Scope: TaBiFoTo provides professional travel photography in designated Japanese cities.\n2. Booking Confirmation: Orders are confirmed upon payment within 72 hours of booking.\n3. Cancellation Policy: Cancellations 14+ days prior receive an 80% refund; 7+ days 50%; within 7 days no refund.",
      "ja-JP": "本利用規約は、TaBiFoTo 旅行写真サービスのご利用に関して規定します。本サービスをご利用いただくことで、本規約に同意したものとみなします。\n\n1. サービス範囲：TaBiFoTo は指定された日本の都市でプロの旅行写真サービスを提供します。\n2. 予約確認：予約後 72 時間以内のお支払いで予約が確定します。\n3. キャンセルポリシー：撮影日 14 日以上前は 80% 返金、7 日以上前は 50% 返金、7 日以内は返金不可。",
    },
    version: "2.1",
    effective_date: "2025-01-01",
    is_active: true,
    created_at: "2025-01-01T00:00:00Z",
    updated_at: "2025-12-01T00:00:00Z",
  },
  {
    id: "legal-002",
    doc_type: "privacy",
    doc_key: "privacy_v1",
    title_i18n: {
      "zh-TW": "隱私權政策",
      "en-US": "Privacy Policy",
      "ja-JP": "プライバシーポリシー",
    },
    content_i18n: {
      "zh-TW": "TaBiFoTo 重視您的個人隱私。本政策說明我們如何收集、使用及保護您的個人資料。\n\n1. 資料收集：姓名、電子郵件、電話及拍攝需求。\n2. 資料用途：僅用於提供攝影服務及改善品質。\n3. 資料保護：採用業界標準加密技術。\n4. 保留期限：服務完成後保留 3 年，期滿依法刪除。",
      "en-US": "TaBiFoTo values your privacy. This Policy explains how we collect, use, and protect your personal information.\n\n1. Data Collection: Name, email, phone, and shoot preferences.\n2. Data Use: Solely to provide photography services and improve quality.\n3. Data Protection: Industry-standard encryption.\n4. Retention: 3 years after service completion, then deleted per applicable law.",
      "ja-JP": "TaBiFoTo はお客様のプライバシーを重視しています。本ポリシーでは個人情報の収集・使用・保護方法をご説明します。\n\n1. データ収集：お名前、メール、電話番号、撮影希望内容。\n2. 使用目的：写真サービス提供とサービス改善のみ。\n3. データ保護：業界標準の暗号化。\n4. 保持期間：サービス完了後 3 年間、その後適法に削除。",
    },
    version: "1.3",
    effective_date: "2025-06-01",
    is_active: true,
    created_at: "2025-06-01T00:00:00Z",
    updated_at: "2025-06-01T00:00:00Z",
  },
  {
    id: "legal-003",
    doc_type: "photo_release",
    doc_key: "photo_release_v1",
    title_i18n: {
      "zh-TW": "照片使用授權書",
      "en-US": "Photo Release Agreement",
      "ja-JP": "写真使用許諾書",
    },
    content_i18n: {
      "zh-TW": "本授權書授予 TaBiFoTo 使用拍攝作品的相關權利。客戶同意 TaBiFoTo 可將成品用於官方網站、社群媒體及行銷材料展示（不標示客戶真實姓名）。客戶保有個人使用及分享拍攝成品的完整權利。",
      "en-US": "This Photo Release Agreement grants TaBiFoTo rights to use session photographs. Client agrees TaBiFoTo may use photos for website, social media, and marketing (without identifying the client by real name). Client retains full rights to personally use and share photos.",
      "ja-JP": "本写真使用許諾書は、撮影写真を TaBiFoTo が使用する権利を付与します。お客様は TaBiFoTo がウェブサイト・SNS・マーケティング資料に写真を使用することに同意します（実名表記なし）。お客様は個人的な使用・共有の完全な権利を保持します。",
    },
    version: "1.0",
    effective_date: "2025-01-01",
    is_active: true,
    created_at: "2025-01-01T00:00:00Z",
    updated_at: "2025-01-01T00:00:00Z",
  },
  {
    id: "legal-004",
    doc_type: "service_agreement",
    doc_key: "service_agreement_v1",
    title_i18n: {
      "zh-TW": "攝影服務契約",
      "en-US": "Photography Service Agreement",
      "ja-JP": "撮影サービス契約書",
    },
    content_i18n: {
      "zh-TW": "本契約規定客戶與 TaBiFoTo 之間的攝影服務範圍、費用、交付物及雙方責任。服務範圍依訂單確認書為準。交付物包含精修照片或影片檔案，於拍攝後 14 個工作日內提供。",
      "en-US": "This agreement defines the scope of photography services, fees, deliverables, and responsibilities between the client and TaBiFoTo. Service scope is per the booking confirmation. Deliverables include edited photos or video files, provided within 14 business days of the shoot.",
      "ja-JP": "本契約は、お客様と TaBiFoTo 間の撮影サービスの範囲・費用・成果物・責任を規定します。サービス範囲は予約確認書に従います。成果物は撮影後 14 営業日以内に提供されます。",
    },
    version: "1.0",
    effective_date: "2025-01-01",
    is_active: true,
    created_at: "2025-01-01T00:00:00Z",
    updated_at: "2025-01-01T00:00:00Z",
  },
  {
    id: "legal-005",
    doc_type: "cancellation",
    doc_key: "cancellation_v1",
    title_i18n: {
      "zh-TW": "取消與改期政策",
      "en-US": "Cancellation & Reschedule Policy",
      "ja-JP": "キャンセル・日程変更ポリシー",
    },
    content_i18n: {
      "zh-TW": "取消政策：拍攝日前 14 天以上取消退還 80%；7 天以上退還 50%；7 天內不退款。\n改期政策：拍攝日前 7 天以上可免費改期一次；7 天內改期需支付 10% 手續費；每筆訂單最多改期 2 次。不可抗力因素（颱風、地震）由雙方協商重新安排。",
      "en-US": "Cancellation: 14+ days prior — 80% refund; 7+ days — 50% refund; within 7 days — no refund.\nReschedule: 7+ days prior — one free reschedule; within 7 days — 10% admin fee applies; maximum 2 reschedules per order. Force majeure events are rescheduled by mutual agreement.",
      "ja-JP": "キャンセル：撮影日 14 日以上前 — 80% 返金；7 日以上前 — 50% 返金；7 日以内 — 返金不可。\n日程変更：7 日以上前 — 1 回無料；7 日以内 — 10% 手数料；最大 2 回まで。不可抗力は双方の合意により再調整。",
    },
    version: "1.1",
    effective_date: "2025-03-01",
    is_active: true,
    created_at: "2025-03-01T00:00:00Z",
    updated_at: "2025-03-01T00:00:00Z",
  },
  {
    id: "legal-006",
    doc_type: "photographer_contract",
    doc_key: "photographer_contract_v1",
    title_i18n: {
      "zh-TW": "攝影師合作契約",
      "en-US": "Photographer Partnership Contract",
      "ja-JP": "フォトグラファー業務委託契約",
    },
    content_i18n: {
      "zh-TW": "本契約規範 TaBiFoTo 與合作攝影師之間的業務委託關係，包括服務範圍、報酬、知識產權、保密義務及合約終止條件。攝影師以獨立承包商身份合作，非雇傭關係。",
      "en-US": "This contract governs the service relationship between TaBiFoTo and partner photographers, including scope of work, compensation, intellectual property, confidentiality, and termination conditions. Photographers operate as independent contractors, not employees.",
      "ja-JP": "本契約は TaBiFoTo とパートナーフォトグラファーの業務委託関係を規定します（業務範囲・報酬・知的財産・守秘義務・契約終了）。フォトグラファーは独立した業務委託者として協力し、雇用関係ではありません。",
    },
    version: "2.0",
    effective_date: "2025-01-01",
    is_active: true,
    created_at: "2025-01-01T00:00:00Z",
    updated_at: "2025-01-01T00:00:00Z",
  },
  {
    id: "legal-007",
    doc_type: "platform_disclaimer",
    doc_key: "",
    title_i18n: {
      "zh-TW": "平台免責聲明",
      "en-US": "Platform Disclaimer",
      "ja-JP": "プラットフォーム免責事項",
    },
    content_i18n: {
      "zh-TW": "TaBiFoTo 平台僅為攝影服務媒合平台。對於因天氣、景點臨時關閉、自然災害或其他不可抗力因素導致的服務中斷，TaBiFoTo 不承擔超出預付款金額的賠償責任。",
      "en-US": "TaBiFoTo operates as a photography service matching platform. For service interruptions due to weather, venue closures, natural disasters, or other force majeure events, TaBiFoTo's liability is limited to the amount paid.",
      "ja-JP": "TaBiFoTo は撮影サービスのマッチングプラットフォームです。天候・会場閉鎖・自然災害等の不可抗力による中断に対し、TaBiFoTo の責任は支払済み金額を上限とします。",
    },
    version: "1.0",
    effective_date: "2025-01-01",
    is_active: false,
    created_at: "2025-01-01T00:00:00Z",
    updated_at: "2025-01-01T00:00:00Z",
  },
  {
    id: "legal-008",
    doc_type: "cross_border",
    doc_key: "cross_border_v1",
    title_i18n: {
      "zh-TW": "跨境服務條款",
      "en-US": "Cross-Border Service Terms",
      "ja-JP": "越境サービス利用規約",
    },
    content_i18n: {
      "zh-TW": "本跨境服務條款適用於非日本居民使用 TaBiFoTo 服務的情況。適用法律為日本法律，爭議解決地點為京都地方法院。付款以新台幣（TWD）計價，匯率損失由客戶承擔。",
      "en-US": "These Cross-Border Terms apply to non-Japan residents using TaBiFoTo services. Governing law is Japanese law; disputes are resolved in Kyoto District Court. Payments are denominated in TWD; exchange rate risk is borne by the client.",
      "ja-JP": "本越境規約は日本在住以外のお客様に適用されます。準拠法は日本法、紛争解決は京都地方裁判所とします。支払いは TWD 建てで、為替リスクはお客様が負担します。",
    },
    version: "1.0",
    effective_date: "2025-06-01",
    is_active: true,
    created_at: "2025-06-01T00:00:00Z",
    updated_at: "2025-06-01T00:00:00Z",
  },
];

// ─── Booking Cost Items ───────────────────────────────────────────────────────

export const MOCK_BOOKING_COST_ITEMS: BookingCostItem[] = [
  {
    id: "bci-001",
    order_id: "ord-001",
    cost_type: "flight",
    amount_twd: 28000,
    currency: "TWD",
    cost_status: "non_refundable",
    description: "Osaka KIX → Taipei TPE return (photographer travel). Non-refundable fare booked 2026-03-10.",
    created_at: "2026-03-10T09:00:00Z",
    updated_at: "2026-03-10T09:00:00Z",
  },
  {
    id: "bci-002",
    order_id: "ord-001",
    cost_type: "accommodation",
    amount_twd: 9600,
    currency: "TWD",
    cost_status: "non_refundable",
    description: "Kyoto Gion guesthouse — 2 nights (2026-04-11 to 04-13). Non-refundable prepaid rate.",
    created_at: "2026-03-10T09:30:00Z",
    updated_at: "2026-03-10T09:30:00Z",
  },
  {
    id: "bci-003",
    order_id: "ord-001",
    cost_type: "local_transport",
    amount_twd: 2400,
    currency: "TWD",
    cost_status: "paid",
    description: "IC card top-up + bus day passes for shoot locations (Arashiyama, Gion).",
    created_at: "2026-03-15T10:00:00Z",
    updated_at: "2026-03-15T10:00:00Z",
  },
  {
    id: "bci-004",
    order_id: "ord-003",
    cost_type: "train",
    amount_twd: 4800,
    currency: "TWD",
    cost_status: "paid",
    description: "Shinkansen Osaka → Kyoto return for photographer on shoot day (2026-04-22).",
    created_at: "2026-03-21T11:00:00Z",
    updated_at: "2026-03-21T11:00:00Z",
  },
  {
    id: "bci-005",
    order_id: "ord-003",
    cost_type: "accommodation",
    amount_twd: 7200,
    currency: "TWD",
    cost_status: "non_refundable",
    description: "Kyoto Nishiki area apartment — 1 night. Non-refundable rate for early access.",
    created_at: "2026-03-21T11:30:00Z",
    updated_at: "2026-03-21T11:30:00Z",
  },
  {
    id: "bci-006",
    order_id: "ord-005",
    cost_type: "flight",
    amount_twd: 42000,
    currency: "TWD",
    cost_status: "booked",
    description: "Tokyo HND → Osaka KIX for drone equipment transport. Partially refundable.",
    created_at: "2026-03-22T09:00:00Z",
    updated_at: "2026-03-22T09:00:00Z",
  },
  {
    id: "bci-007",
    order_id: "ord-005",
    cost_type: "ticket",
    amount_twd: 1200,
    currency: "TWD",
    cost_status: "estimated",
    description: "Arashiyama Bamboo Grove guided tour access — required for drone permit application area.",
    created_at: "2026-03-22T09:30:00Z",
    updated_at: "2026-03-22T09:30:00Z",
  },
  {
    id: "bci-008",
    order_id: "ord-002",
    cost_type: "train",
    amount_twd: 3500,
    currency: "TWD",
    cost_status: "estimated",
    description: "Nara–Kyoto day trip connector for possible extended shoot scope.",
    created_at: "2026-03-19T15:00:00Z",
    updated_at: "2026-03-19T15:00:00Z",
  },
];

// ─── Booking Notes ────────────────────────────────────────────────────────────

export const MOCK_BOOKING_NOTES: BookingNote[] = [
  {
    id: "bn-001",
    order_id: "ord-001",
    note_type: "internal",
    content: "Photographer confirmed Arashiyama bamboo grove + Gion cobblestone route. Recommend 06:00 start to avoid crowds. Check kimono rental availability at Yumeyakata for customer if requested.",
    created_by: "admin@tabifoto.com",
    created_at: "2026-03-20T11:00:00Z",
  },
  {
    id: "bn-002",
    order_id: "ord-001",
    note_type: "customer_visible",
    content: "Your shoot is confirmed for April 12. Please arrive at Arashiyama Station (JR Sagano Line) by 08:50. Your photographer Kenji will meet you at the station exit. Wear comfortable walking shoes.",
    created_by: "ops@tabifoto.com",
    created_at: "2026-03-20T12:30:00Z",
  },
  {
    id: "bn-003",
    order_id: "ord-001",
    note_type: "photographer_visible",
    content: "Customer (Wang Li-Hua) speaks Mandarin and basic English. Prefers editorial-style framing over posed. Bring props if possible. End shoot at Gion corner area for evening light if time allows.",
    created_by: "ops@tabifoto.com",
    created_at: "2026-03-20T13:00:00Z",
  },
  {
    id: "bn-004",
    order_id: "ord-002",
    note_type: "internal",
    content: "Customer wants vertical-format reels for Instagram. Confirm with assigned photographer to shoot in 9:16 mode throughout. Awaiting photographer assignment — check availability for April 18.",
    created_by: "admin@tabifoto.com",
    created_at: "2026-03-19T14:30:00Z",
  },
  {
    id: "bn-005",
    order_id: "ord-003",
    note_type: "internal",
    content: "Customer bringing own furisode kimono. Confirm fitting time is not needed. Shirakawa canal section has limited morning light — schedule Heian Shrine for golden hour. Yuki confirmed.",
    created_by: "admin@tabifoto.com",
    created_at: "2026-03-21T12:00:00Z",
  },
  {
    id: "bn-006",
    order_id: "ord-005",
    note_type: "internal",
    content: "DRONE PERMIT STATUS: Arashiyama Bamboo Grove is a Class 2 drone zone. Application submitted to Kyoto Prefecture on 2026-03-22. Approval expected in 2–3 weeks. DO NOT confirm order until permit approved.",
    created_by: "admin@tabifoto.com",
    created_at: "2026-03-22T10:00:00Z",
  },
  {
    id: "bn-007",
    order_id: "ord-005",
    note_type: "photographer_visible",
    content: "Drone permit pending. If permit is denied, discuss alternative aerial locations (Kinkakuji parking area may have limited drone access). Customer is aware of the conditional status.",
    created_by: "ops@tabifoto.com",
    created_at: "2026-03-23T09:00:00Z",
  },
];

// ─── Order Cancellation Logs ──────────────────────────────────────────────────

export const MOCK_ORDER_CANCELLATION_LOGS: OrderCancellationLog[] = [
  {
    id: "ocl-001",
    order_id: "ord-004",
    cancelled_at: "2026-04-01T10:00:00Z",
    cancelled_by: "customer",
    reason: "Customer travel plans changed due to family emergency. Requested full cancellation before shoot date.",
    refund_amount_twd: 24500,
    penalty_amount_twd: 10500,
    non_refundable_cost_twd: 9600,
    note: "Non-refundable costs include Osaka hotel (7,200) and airport transfer prepay (2,400). Penalty applied per 14-day cancellation policy. Refund issued to original payment method within 7 business days.",
  },
  {
    id: "ocl-002",
    order_id: "ord-002",
    cancelled_at: "2026-03-28T15:00:00Z",
    cancelled_by: "ops",
    reason: "No photographer available in Kyoto on April 18. Operations team initiated cancellation after 9-day search failure.",
    refund_amount_twd: 48000,
    penalty_amount_twd: 0,
    non_refundable_cost_twd: 3500,
    note: "Full order refund issued as cancellation was initiated by TaBiFoTo. Non-refundable cost (train reservation 3,500) absorbed by company. Customer notified via email and offered priority rebooking for next available date.",
  },
];

// ─── Order Reschedule Logs ────────────────────────────────────────────────────

export const MOCK_ORDER_RESCHEDULE_LOGS: OrderRescheduleLog[] = [
  {
    id: "orl-001",
    order_id: "ord-001",
    original_shoot_date: "2026-04-10",
    new_shoot_date: "2026-04-12",
    requested_at: "2026-03-18T14:00:00Z",
    approved_at: "2026-03-19T09:00:00Z",
    reason: "Customer requested 2-day postponement — cherry blossom peak predicted April 12 for Arashiyama.",
    reschedule_count: 1,
    note: "Photographer Kenji confirmed availability for April 12. No extra cost. Accommodation rebooking handled internally.",
  },
  {
    id: "orl-002",
    order_id: "ord-003",
    original_shoot_date: "2026-04-20",
    new_shoot_date: "2026-04-22",
    requested_at: "2026-03-20T10:00:00Z",
    approved_at: "2026-03-21T11:00:00Z",
    reason: "Venue scheduling conflict at Heian Shrine on April 20 (private event). Rescheduled to April 22 to avoid closure.",
    reschedule_count: 1,
    note: "Confirmed with Heian Shrine — April 22 is fully open to visitors. Yuki availability confirmed.",
  },
  {
    id: "orl-003",
    order_id: "ord-005",
    original_shoot_date: "2026-05-01",
    new_shoot_date: "2026-05-08",
    requested_at: "2026-03-24T10:00:00Z",
    approved_at: null,
    reason: "Pending drone permit approval for Arashiyama. Shoot rescheduled 1 week to allow permit processing window.",
    reschedule_count: 1,
    note: "Awaiting Kyoto Prefecture permit decision. If permit denied by 2026-04-28, customer will be contacted for alternative date or scope reduction. This reschedule is conditional.",
  },
];
